import { inject } from "@angular/core";
import { CanActivateFn, Router, UrlTree } from "@angular/router";

import { isSupported, localStore, sessionStore } from "@auvious/utils";

import { ErrorPageCode } from "../../app.enums";

export const agentCompatibilityGuard: CanActivateFn = (route, state): boolean | UrlTree => {
  const router = inject(Router);

  //   try{
  //   // Without storage authentication will not work. It actually could work, if we accepted whatever state we receive
  //   // without checking the stored state, but this leaves our app open to csrf attacks.
  //   if (!isSupported(localStorage) || !isSupported(sessionStore)) {
  //     return router.createUrlTree([
  //       "/error",
  //       ErrorPageCode.COOKIES_DISABLED,
  //     ]);
  //   }
  // } catch(ex){

  // }

  return true;
};
